<template>
    <div>
        <span v-show="!isLoading && !infos.length">暂无资讯</span>
        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in infos" :key="v.id">
                <router-link class="video-lists-link" :to="`/info/${v.id}`" :title="v.name">
                    <div class="pr">
                        <div class="video-thumb-mask"></div>
                        <img class="video-thumb" v-lazy="v.thumb">
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`舞蹈风格: ${v.cate}`">{{v.cate}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-comments" :title="`时间: ${v.addtime}`">
                            <i class="icon-clock"></i> {{v.addtime}}
                            </span>
                        </p>
                    </div>
                </router-link>
            </li>
        </ul>

        <el-pagination v-if="infoTotal > 40" :current-page="page"  @current-change="currentChange" :page-size="40" :total="infoTotal" background layout="total, prev, pager, next"></el-pagination>
    </div>

</template>

<script>
    export default {
        props: {
            infoTotal: Number,
        },
        data: () => ({
            infos: [],
            isLoading: true,
        }),
        computed: {
            id () {
                return +this.$route.params.id || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            },
        },
        methods: {
            currentChange(page) {
                this.$router.push(`?page/${page}`);
            },
        },
        async beforeMount() {
            this.infos = await this.api.get(`studios/${this.id}/info`, {page: this.page}).catch(this.err);
            this.isLoading = false;
        },
        async beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            this.isLoading = true;
            let {page} = to.query;
            this.infos = await this.api.get(`studios/${this.id}/info`, {page}).catch(this.err);
            this.isLoading = false;
            next();
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";

    .video-thumb-mask {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.2);
        -webkit-transition: opacity .3s;
        -o-transition: opacity .3s;
        transition: opacity .3s;
    }

    .video-thumb-box {
        position: relative;
    }

    .video-lists-link:hover .video-thumb-mask {
        opacity: 1;
    }
</style>


// WEBPACK FOOTER //
// src/views/studio/Info.vue